import React, { useEffect, useState, useCallback } from 'react';

export const LogoAnimation = ({ onComplete }) => {
  const [isAnimating, setIsAnimating] = useState(true);

  const handleComplete = useCallback(() => {
    setIsAnimating(false);
    onComplete?.();
  }, [onComplete]);

  useEffect(() => {
    // Check if animation has been shown before
    const hasSeenAnimation = sessionStorage.getItem('bekarLogoShown');
    
    if (hasSeenAnimation) {
      handleComplete();
      return;
    }

    // Mark as shown and complete after animation
    const timer = setTimeout(() => {
      sessionStorage.setItem('bekarLogoShown', 'true');
      handleComplete();
    }, 3500);

    return () => clearTimeout(timer);
  }, [handleComplete]);

  if (!isAnimating) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-black flex items-center justify-center overflow-hidden">
      {/* Animated BEKÂR Logo Outline */}
      <div className="logo-animation-container">
        <img 
          src="https://customer-assets.emergentagent.com/job_bekar-360-platform/artifacts/wqp38ft8_Untitled%20design.png"
          alt="BEKÂR"
          className="logo-reveal"
          style={{
            width: '40vw',
            height: 'auto',
            maxWidth: '600px',
            minWidth: '300px'
          }}
        />
      </div>
    </div>
  );
};
